
export const gender = {
    MALE: 1329,
    FEMALE: 1330,
}

export const customerType = {
    MULTI_ACCOUNT_OWNER: 1326,
    REAL: 1327,
    LEGAL: 1328,
}

export const owneringType = {
    RENTAL: 1362,
    PRIVATE_PROPERTY: 1361,
}

export const assignType = {
    CONTRACTUAL: 4632,
    ON_SALE: 4633,
}

export const trustKind = {
    CHECK: 1,
    CASH: 2,
    ACCOUNT_BLOCKING: 3,
    NO_DEPOSIT: 4,
    REPRESENTATION_GURANTEE: 5,
}
